import { addIcons } from 'ionicons';
import {
  checkmarkCircleOutline,
  closeCircleOutline,
  documentTextOutline,
  notificationsOutline,
  refreshOutline,
  timeOutline,
  warningOutline,
} from 'ionicons/icons';

/**
 * The icon for a notification `type`. Shared by the Notifikasi page and the
 * in-app banner a foreground push shows, so the two always match.
 */
export interface NotificationIcon {
  name: string;
  /** Tailwind classes for the tinted circle and the glyph inside it. */
  tone: string;
}

const RED = 'bg-[#FDE4E3] text-[#DA3833]';

const ICONS: Record<string, NotificationIcon> = {
  approved: { name: 'checkmark-circle-outline', tone: 'bg-[#E3F5EA] text-[#1E9E5A]' },
  rejected: { name: 'close-circle-outline', tone: RED },
  overdue: { name: 'warning-outline', tone: RED },
  deadline: { name: 'time-outline', tone: 'bg-[#FDF0D5] text-[#B7791F]' },
  resubmit: { name: 'refresh-outline', tone: RED },
  draft: { name: 'document-text-outline', tone: 'bg-[#E3ECF7] text-[#3B5B85]' },
};

/** Until the API sends `type`, and for any type this app does not know yet. */
const FALLBACK_ICON: NotificationIcon = {
  name: 'notifications-outline',
  tone: 'bg-[#EEF0F2] text-[#4B4B4B]',
};

export const iconFor = (type: string | undefined): NotificationIcon =>
  (type && ICONS[type]) || FALLBACK_ICON;

/** Standalone Ionic does not auto-register icons; call before rendering any of these. */
export const registerNotificationIcons = (): void => {
  addIcons({
    checkmarkCircleOutline,
    closeCircleOutline,
    documentTextOutline,
    notificationsOutline,
    refreshOutline,
    timeOutline,
    warningOutline,
  });
};
